<template>
  <div class="container">
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Reservas de gas en México</h1>
      <hr/>

      <p class="texto-principal">La situación de las reservas de gas natural es similar a la del petróleo, ya que una buena parte de la producción nacional es gas asociado al petróleo. Al 1 de enero de 2021 las reservas probadas de gas natural corresponden a 9,981 MMMpc (CNH, 2022), lo que corresponde a 6 años de la producción 2020. Si se toman en cuenta las reservas 3P, serían 17 años. El caso del gas es particularmente grave debido a que México importa gran parte del gas que utiliza de Estados Unidos.</p>
      
    </div>

    <div>

    <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Reservas de gas</h3>
            <p class="texto-notas">Datos en MMMpc. Actualización: 2023.</p>
          </div>
          <div class="contenido">
            <div class="barrasReservas" ref="barrasReservas">
            </div>
          </div>
          <div class="tarjeta-contendor-notas">
              <p class="texto-notas"></p>
          </div>
      </div>


      
    <br>
      
      <dai-tarjeta-contenedor-mapa :permitir-colapso="true" altura-colapsada="80vh">
      
      <template v-slot:header>
            <h3>Distribución de las Reservas de Gas por Provincia Petrolera</h3> 

            <dai-selector-mapa 
            v-model="selectorCategoria"
            class="control-large" 
            @change="cambioSelector"
            >
                <option value="1p">1P (Probadas)</option>
                <option value="2p">2P (1P + Probables)</option>
                <option value="3p">3P (2P + Posibles)</option>
            </dai-selector-mapa>

            <p class="texto-notas " v-width-control="'100%'" >Selecciona una categoría para cambiar la vista del mapa. Haz clic en los circulos para ver los datos de las reservas.</p>
            
            <dai-leyenda-mapa v-show="selectorCategoria==='1p'"
            titulo="Reservas de gas (MMMpc)"
            :para="['distribucion_reserva_provincia_petrolera_1p']"
            />

            <dai-leyenda-mapa v-show="selectorCategoria==='2p'"
            titulo="Reservas de gas (MMMpc)"
            :para="['distribucion_reserva_provincia_petrolera_2p']"
            />

            <dai-leyenda-mapa v-show="selectorCategoria==='3p'"
            titulo="Reservas de gas (MMMpc)"
            :para="['distribucion_reserva_provincia_petrolera_3p']"
            />

      </template>

      <dai-mapa
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
      >
          
      <dai-capa-xyz url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>


      <dai-capa-geojson :visible="selectorCategoria==='1p'"
      id="distribucion_reserva_provincia_petrolera_1p"
      titulo="Reservas de gas"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.GAS_MMMPC.toFixed(2)} MMMpc `"
      url="../geodata/hidrocarburos/reservas2020_1P.geojson"
      :reglas-estilo-capa="[
        {
            clasificacion:'categorias',
            columna : 'CUENCA',
            acomodoCategorias:['Burgos','Cinturon Plegado de Chiapas','Cuencas del Sureste','Golfo de Mexico Profundo','Licitaciones','Plataforma Burro-Picachos','Sabinas','Tampico-Misantla','Veracruz'],
            propiedadObjetivo: 'relleno',
            colores:['#02c620','#c25737','#dd2a60','#39d0d5','#d1308b','#b323cc','#cce187','#d91ac9','#dd9211'],
            tituloVariable:'Cuenca'
        },
        {
            clasificacion:'personalizada',
            columna:'GAS_MMMPC',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,500],[500,1000],[1000,2500],[2500,6000]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Miles de millones de pies cúbicos (MMMpc)'
        }
      ]"
      />

      <dai-capa-geojson :visible="selectorCategoria==='2p'"
      id="distribucion_reserva_provincia_petrolera_2p"
      titulo="Reservas de gas"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.GAS_MMMPC.toFixed(2)} MMMpc `"
      url="../geodata/hidrocarburos/reservas2020_2P.geojson"
      :reglas-estilo-capa="[
        {
            clasificacion:'categorias',
            columna : 'CUENCA',
            acomodoCategorias:['Burgos','Cinturon Plegado de Chiapas','Cuencas del Sureste','Golfo de Mexico Profundo','Licitaciones','Plataforma Burro-Picachos','Sabinas','Tampico-Misantla','Veracruz'],
            propiedadObjetivo: 'relleno',
            colores:['#02c620','#c25737','#dd2a60','#39d0d5','#d1308b','#b323cc','#cce187','#d91ac9','#dd9211'],
            tituloVariable:'Cuenca'
        },
        {
            clasificacion:'personalizada',
            columna:'GAS_MMMPC',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,500],[500,1000],[1000,2500],[2500,6000]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Miles de millones de pies cúbicos (MMMpc)'
        }
      ]"
      />

      <dai-capa-geojson :visible="selectorCategoria==='3p'"
      id="distribucion_reserva_provincia_petrolera_3p"
      titulo="Reservas de gas"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.GAS_MMMPC.toFixed(2)} MMMpc `"
      url="../geodata/hidrocarburos/reservas2020_3P.geojson"
      :reglas-estilo-capa="[
        {
            clasificacion:'categorias',
            columna : 'CUENCA',
            acomodoCategorias:['Burgos','Cinturon Plegado de Chiapas','Cuencas del Sureste','Golfo de Mexico Profundo','Licitaciones','Plataforma Burro-Picachos','Sabinas','Tampico-Misantla','Veracruz'],
            propiedadObjetivo: 'relleno',
            colores:['#02c620','#c25737','#dd2a60','#39d0d5','#d1308b','#b323cc','#cce187','#d91ac9','#dd9211'],
            tituloVariable:'Cuenca'
        },
        {
            clasificacion:'personalizada',
            columna:'GAS_MMMPC',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,500],[500,1000],[1000,2500],[2500,6000]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Miles de millones de pies cúbicos (MMMpc)'
        }
      ]"
      />
  
      </dai-mapa>


      </dai-tarjeta-contenedor-mapa>

      <br>

      <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Reservas de gas por ubicación</h3>
            <p class="texto-notas">Datos en MMMpc. Actualización: 2020.</p>
            <select v-model="reservas_ubicacion_select" id="reservas-ubicacion-select">
              <option value="1P">1P (Probadas)</option>
              <option value="2P">2P (1P + Probables)</option>
              <option value="3P">3P (2P + Posibles)</option>
            </select>
          </div>
          <div class="contenido">
            <div class="barrasReservasUbicacion" ref="barrasReservasUbicacion">
            </div>
          </div>
          <div class="tarjeta-contendor-notas">
              <p class="texto-notas"></p>
          </div>
      </div>

      
    </div>
    
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <p class="texto-principal">A diferencia del petróleo la mayor parte de las reservas de gas están en campos terrestres. Para 2022 los capos Ixachi, Quesqui, Akal, Lakach, Maloob, Ku, Ichalkil, Onel, Teotleco, Cuitlahuac, concentratron el 52% de las reservas de gas. Ixachi, por si solo, contiene el 18% de las reservas probadas de gas, mientras que el campo Quesqui el 13%.</p>
    </div>

    <div>
      <dai-tarjeta-contenedor-mapa :permitir-colapso="false" altura-colapsada="400vh">
      
      <template v-slot:header>
            <h3>Distribución de las Reservas por Campo</h3> 

            <dai-selector-mapa 
            v-model="selectorCategoriaCampo"
            class="control-large" 
            @change="cambioSelector"
            >
                <option value="1p">1P (Probadas)</option>
                <option value="2p">2P (1P + Probables)</option>
                <option value="3p">3P (2P + Posibles)</option>
            </dai-selector-mapa>

            <dai-buscador-mapa 
            para="distribucion_campo_petrolero_1p"
            :acceso-opciones="(f)=>f.CAMPO"
            placeholder="Buscar campo"
            />

            <p class="texto-notas " v-width-control="'100%'" >Haz clic en el selector de categoría para cambiar la vista del mapa. Utiliza el cuadro de búsqueda para identificar y hacer zoom sobre los campos petroleros.</p>
            
            <dai-leyenda-mapa v-show="selectorCategoriaCampo==='1p'"
            titulo="Reservas de gas (MMMPC)"
            :para="['distribucion_campo_petrolero_1p']"
            />

            <dai-leyenda-mapa v-show="selectorCategoriaCampo==='2p'"
            titulo="Reservas de gas (MMMPC)"
            :para="['distribucion_campo_petrolero_2p']"
            />

            <dai-leyenda-mapa v-show="selectorCategoriaCampo==='3p'"
            titulo="Reservas de gas (MMMPC)"
            :para="['distribucion_campo_petrolero_3p']"
            />

      </template>

      <dai-mapa
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
      >
          
      <dai-capa-xyz url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>


      <dai-capa-geojson :visible="selectorCategoriaCampo==='1p'"
      id="distribucion_campo_petrolero_1p"
      titulo="Reservas de gas"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.GAS_MMMPC.toFixed(2)} MMMpc`"
      url="../geodata/hidrocarburos/reservas2020_1P.geojson"
      :reglas-estilo-capa="[
        /*{
            clasificacion:'categorias',
            columna : 'CAMPO',
            propiedadObjetivo: 'relleno',
            tituloVariable:'Campo'
        },*/
        {
            clasificacion:'personalizada',
            columna:'GAS_MMMPC',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,500],[500,1000],[1000,2500],[2500,6000]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Miles de millones de pies cúbicos (MMMpc)'
        }
      ]"
      />

      <dai-capa-geojson :visible="selectorCategoriaCampo==='2p'"
      id="distribucion_campo_petrolero_2p"
      titulo="Reservas de gas"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.GAS_MMMPC.toFixed(2)} MMMpc`"
      url="../geodata/hidrocarburos/reservas2020_2P.geojson"
      :reglas-estilo-capa="[
        /*{
            clasificacion:'categorias',
            columna : 'CAMPO',
            propiedadObjetivo: 'relleno',
            tituloVariable:'Campo'
        },*/
        {
            clasificacion:'personalizada',
            columna:'GAS_MMMPC',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,500],[500,1000],[1000,2500],[2500,6000]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Miles de millones de pies cúbicos (MMMpc)'
        }
      ]"
      />

      <dai-capa-geojson :visible="selectorCategoriaCampo==='3p'"
      id="distribucion_campo_petrolero_3p"
      titulo="Reservas de gas"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.GAS_MMMPC.toFixed(2)} MMMpc`"
      url="../geodata/hidrocarburos/reservas2020_3P.geojson"
      :reglas-estilo-capa="[
        /*{
            clasificacion:'categorias',
            columna : 'CAMPO',
            propiedadObjetivo: 'relleno',
            tituloVariable:'Campo'
        },*/
        {
            clasificacion:'personalizada',
            columna:'GAS_MMMPC',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,500],[500,1000],[1000,2500],[2500,6000]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Miles de millones de pies cúbicos (MMMpc)'
        }
      ]"
      />
  
      </dai-mapa>

      </dai-tarjeta-contenedor-mapa>


    </div>

    <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
              <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
              <ul class="lista-referencias">
                <li><em><strong>Comisión Nacional de Hidrocarburos (CNH) (2022).</strong></em> Reporte de la Cuantificación y Certificación de las Reservas de la Nación del año 2022. <a href="https://www.gob.mx/cnh/acciones-y-programas/cuantificacion-y-certificacion-de-reservas" target="_blank">https://www.gob.mx/cnh/acciones-y-programas/cuantificacion-y-certificacion-de-reservas</a></li>
              </ul>            
          </div>
  </div>
</template>
<script>
  
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES";
  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  

  export default {
    name: 'App',
    components: {
    },
    data: function () {
      return {
        selectorCategoria:'1p',
        selectorCategoriaCampo:'1p',
        reservasDatos:reservasDatos,
        reservasVariables: reservasVariables,
        reservasUbicacionDatos1P: reservasUbicacionDatos1P,
        reservasUbicacionDatos2P: reservasUbicacionDatos2P,
        reservasUbicacionDatos3P: reservasUbicacionDatos3P,
        reservasUbicacionVariables: reservasUbicacionVariables,
        reservas_ubicacion_select:'1P'
      }   
    },
    methods:{
        cambioSelector:function(e){
            
        },
    },
    watch: {
      reservas_ubicacion_select: function(val, oldVal) {
          if(val == '1P') this.chartReservasUbicacion.data = reservasUbicacionDatos1P;
          else if(val == '2P') this.chartReservasUbicacion.data = reservasUbicacionDatos2P;
          else if(val == '3P') this.chartReservasUbicacion.data = reservasUbicacionDatos3P;
        }
    },
    mounted() {

      let chartReservas = am4core.create(this.$refs.barrasReservas, am4charts.XYChart);
      chartReservas.maskBullets = false;
      chartReservas.paddingLeft = 20;
      chartReservas.paddingRight = 50;
      chartReservas.fontSize = 12;
      chartReservas.language.locale = am4lang_es_ES;
      chartReservas.language.locale["_decimalSeparator"] = ".";
      chartReservas.language.locale["_thousandSeparator"] = ",";
      chartReservas.exporting.menu = new am4core.ExportMenu();
      chartReservas.exporting.filePrefix = "ReservasGas";
      chartReservas.exporting.useWebFonts = false;
      chartReservas.data = reservasDatos;

      // Create axes
      let categoryAxis3 = chartReservas.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis3.dataFields.category = "a";
      categoryAxis3.renderer.grid.template.location = 0;
      categoryAxis3.renderer.minGridDistance = 10;

      let valueAxis3 = chartReservas.yAxes.push(new am4charts.ValueAxis());
      //valueAxis3.renderer.inside = true;
      //valueAxis3.renderer.labels.template.disabled = true;
      valueAxis3.title.text = "MMMPC";
      valueAxis3.min = 0;
      valueAxis3.extraMax = 0.1;
      valueAxis3.calculateTotals = true;

      // Create series
      function createSeries3(field, name, color) {
        
        // Set up series
        let series = chartReservas.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "a";
        series.sequencedInterpolation = true;
        series.fill = am4core.color(color);
        series.tooltip.background.fill = am4core.color(color);
        // Make it stacked
        series.stacked = true;
        series.fillOpacity = 0.8;
        series.strokeWidth = 0;
        

        // Configure columns
        series.columns.template.width = am4core.percent(60);
        series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

        return series;
      }

      for(var i=0; i<reservasVariables.length; i++)
      {
        let v = reservasVariables[i];
        createSeries3(v.id, v.nombre,v.color);
      }


      var totalSeriesProd = chartReservas.series.push(new am4charts.ColumnSeries());
      totalSeriesProd.dataFields.valueY = "total";
      totalSeriesProd.dataFields.categoryX = "a";
      totalSeriesProd.stacked = true;
      totalSeriesProd.hiddenInLegend = true;
      totalSeriesProd.columns.template.strokeOpacity = 0;

      var totalBulletProd = totalSeriesProd.bullets.push(new am4charts.LabelBullet());
      totalBulletProd.dy = -10;
      totalBulletProd.label.text = "{valueY.total.formatNumber('#.0')}";
      totalBulletProd.label.hideOversized = false;
      totalBulletProd.label.fontSize = 10;
      totalBulletProd.label.fill = am4core.color("#333");
      totalBulletProd.label.background.fillOpacity = 0.2;
      totalBulletProd.label.padding(5, 5, 5, 5);

      // Legend
      chartReservas.legend = new am4charts.Legend();
      chartReservas.legend.useDefaultMarker = true;
      let marker3 = chartReservas.legend.markers.template.children.getIndex(0);
      marker3.cornerRadius(12, 12, 12, 12);
      marker3.strokeWidth = 2;
      marker3.strokeOpacity = 1;
      marker3.stroke = am4core.color("#fff");

      this.chartReservas = chartReservas;

      //barrasReservasUbicacion
      let chartReservasUbicacion = am4core.create(this.$refs.barrasReservasUbicacion, am4charts.XYChart);
      chartReservasUbicacion.language.locale = am4lang_es_ES;
      chartReservasUbicacion.language.locale["_decimalSeparator"] = ".";
      chartReservasUbicacion.language.locale["_thousandSeparator"] = ",";
      chartReservasUbicacion.exporting.menu = new am4core.ExportMenu();
      chartReservasUbicacion.exporting.filePrefix = "ReservasUbicacion";
      chartReservasUbicacion.exporting.useWebFonts = false;
      chartReservasUbicacion.maskBullets = false;
      chartReservasUbicacion.paddingLeft = 20;
      chartReservasUbicacion.paddingRight = 50;
      chartReservasUbicacion.fontSize = 12;

      chartReservasUbicacion.data = reservasUbicacionDatos1P;

      // Create axes
      let categoryAxis4 = chartReservasUbicacion.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis4.dataFields.category = "a";
      categoryAxis4.renderer.grid.template.location = 0;
      categoryAxis4.renderer.minGridDistance = 10;

      let valueAxis4 = chartReservasUbicacion.yAxes.push(new am4charts.ValueAxis());
      //valueAxis3.renderer.inside = true;
      //valueAxis3.renderer.labels.template.disabled = true;
      valueAxis4.title.text = "MMB";
      valueAxis4.min = 0;
      valueAxis4.extraMax = 0.1;
      valueAxis4.calculateTotals = true;

      // Create series
      function createSeries4(field, name, color) {
        
        // Set up series
        let series = chartReservasUbicacion.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "a";
        series.sequencedInterpolation = true;
        series.fill = am4core.color(color);
        series.tooltip.background.fill = am4core.color(color);
        // Make it stacked
        series.stacked = true;
        series.fillOpacity = 0.8;
        series.strokeWidth = 0;
        

        // Configure columns
        series.columns.template.width = am4core.percent(60);
        series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

        return series;
      }

      for(var i=0; i<reservasUbicacionVariables.length; i++)
      {
        let v = reservasUbicacionVariables[i];
        createSeries4(v.id, v.nombre,v.color);
      }


      var totalSeriesProdUbicacion = chartReservasUbicacion.series.push(new am4charts.ColumnSeries());
      totalSeriesProdUbicacion.dataFields.valueY = "total";
      totalSeriesProdUbicacion.dataFields.categoryX = "a";
      totalSeriesProdUbicacion.stacked = true;
      totalSeriesProdUbicacion.hiddenInLegend = true;
      totalSeriesProdUbicacion.columns.template.strokeOpacity = 0;

      var totalBulletProdUbicacion = totalSeriesProdUbicacion.bullets.push(new am4charts.LabelBullet());
      totalBulletProdUbicacion.dy = -10;
      totalBulletProdUbicacion.label.text = "{valueY.total.formatNumber('#.0')}";
      totalBulletProdUbicacion.label.hideOversized = false;
      totalBulletProdUbicacion.label.fontSize = 10;
      totalBulletProdUbicacion.label.fill = am4core.color("#333");
      totalBulletProdUbicacion.label.background.fillOpacity = 0.2;
      totalBulletProdUbicacion.label.padding(5, 5, 5, 5);

      // Legend
      chartReservasUbicacion.legend = new am4charts.Legend();
      chartReservasUbicacion.legend.useDefaultMarker = true;
      let marker4 = chartReservasUbicacion.legend.markers.template.children.getIndex(0);
      marker4.cornerRadius(12, 12, 12, 12);
      marker4.strokeWidth = 2;
      marker4.strokeOpacity = 1;
      marker4.stroke = am4core.color("#fff");

      this.chartReservasUbicacion = chartReservasUbicacion;

        
    },
    beforeDestroy() {
      if (this.chartReservas) {
        this.chartReservas.dispose();
      }

      if (this.chartReservasUbicacion) {
        this.chartReservasUbicacion.dispose();
      }
    },
  }

  
const reservasDatos = [
  {
    "a": "2001",
    "1P": 41382.9341,
    "2P": 56691.78972,
    "3P": 76434.9481
  },
  {
    "a": "2002",
    "1P": 38949.55103,
    "2P": 52806.32752,
    "3P": 69104.95682
  },
  {
    "a": "2003",
    "1P": 21626.08664,
    "2P": 43696.93982,
    "3P": 65432.87889
  },
  {
    "a": "2004",
    "1P": 20740.16919,
    "2P": 41214.16085,
    "3P": 63892.81608
  },
  {
    "a": "2005",
    "1P": 20432.52429,
    "2P": 41135.94143,
    "3P": 63878.76921
  },
  {
    "a": "2006",
    "1P": 19956.89496,
    "2P": 40043.43535,
    "3P": 62354.79612
  },
  {
    "a": "2007",
    "1P": 18957.30034,
    "2P": 39439.12394,
    "3P": 63045.24007
  },
  {
    "a": "2008",
    "1P": 18076.70643,
    "2P": 38638.84232,
    "3P": 61358.54562
  },
  {
    "a": "2009",
    "1P": 17649.48946,
    "2P": 37759.95129,
    "3P": 60374.26662
  },
  {
    "a": "2010",
    "1P": 16814.57106,
    "2P": 37508.85135,
    "3P": 61236.04187
  },
  {
    "a": "2011",
    "1P": 17316.26297,
    "2P": 38221.66005,
    "3P": 61266.0153
  },
  {
    "a": "2012",
    "1P": 17224.38181,
    "2P": 34836.84525,
    "3P": 61640.87467
  },
  {
    "a": "2013",
    "1P": 17075.41326,
    "2P": 34902.26157,
    "3P": 63229.38382
  },
  {
    "a": "2014",
    "1P": 16548.50275,
    "2P": 33264.05206,
    "3P": 59664.75178
  },
  {
    "a": "2015",
    "1P": 15290.49103,
    "2P": 30606.55875,
    "3P": 54889.60759
  },
  {
    "a": "2016",
    "1P": 12651.44888,
    "2P": 22026.30131,
    "3P": 32567.90462
  },
  {
    "a": "2017",
    "1P": 10402.03437,
    "2P": 19300.86825,
    "3P": 28950.33767
  },
  {
    "a": "2018",
    "1P": 10022.42037,
    "2P": 19377.87207,
    "3P": 30020.35203
  },
  {
    "a": "2019",
    "1P": 9654.351379,
    "2P": 20824.35051,
    "3P": 32367.58409
  },
  {
    "a": "2020",
    "1P": 9285.565337,
    "2P": 20939.8391,
    "3P": 29702.98723
  },
  {
    "a": "2021",
    "1P": 9980.953326,
    "2P": 20391.85193,
    "3P": 30764.46156
  },
  {
    "a": "2022",
    "1P": 10780.96352,
    "2P": 21460.10684,
    "3P": 31014.84109
  },
  {
    "a": "2023",
    "1P": 11028.8,
    "2P": 20565.4,
    "3P": 31558.2
  }
],
reservasVariables = [
  {"id":"1P","nombre":"1P (Probadas)","color":"#6c1e01"},
  {"id":"2P","nombre":"2P (1P + Probables)","color":"#d83b01"},
  {"id":"3P","nombre":"3P (2P + Posibles)","color":"#dccb0d"}
];

const reservasUbicacionDatos1P = [
  {
    "a": "2001",
    "marino": 8334.167118,
    "terrestre": 33048.76698
  },
  {
    "a": "2002",
    "marino": 7866.778416,
    "terrestre": 31082.77261
  },
  {
    "a": "2003",
    "marino": 7514.225012,
    "terrestre": 14111.86163
  },
  {
    "a": "2004",
    "marino": 7173.179731,
    "terrestre": 13566.98945
  },
  {
    "a": "2005",
    "marino": 7259.988988,
    "terrestre": 13172.53531
  },
  {
    "a": "2006",
    "marino": 7143.977516,
    "terrestre": 12812.91744
  },
  {
    "a": "2007",
    "marino": 7159.007216,
    "terrestre": 11798.29313
  },
  {
    "a": "2008",
    "marino": 6890.929452,
    "terrestre": 11185.77698
  },
  {
    "a": "2009",
    "marino": 7197.537828,
    "terrestre": 10451.95163
  },
  {
    "a": "2010",
    "marino": 6717.870187,
    "terrestre": 10096.70087
  },
  {
    "a": "2011",
    "marino": 7401.411944,
    "terrestre": 9914.851028
  },
  {
    "a": "2012",
    "marino": 7163.440762,
    "terrestre": 10060.94105
  },
  {
    "a": "2013",
    "marino": 7229.138677,
    "terrestre": 9846.274585
  },
  {
    "a": "2014",
    "marino": 7233.542511,
    "terrestre": 9314.960242
  },
  {
    "a": "2015",
    "marino": 6791.270676,
    "terrestre": 8499.220358
  },
  {
    "a": "2016",
    "marino": 6150.22293,
    "terrestre": 6501.225953
  },
  {
    "a": "2017",
    "marino": 4895.6288,
    "terrestre": 5506.405571
  },
  {
    "a": "2018",
    "marino": 4906.878727,
    "terrestre": 5115.541638
  },
  {
    "a": "2019",
    "marino": 3862.251346,
    "terrestre": 5792.100033
  },
  {
    "a": "2020",
    "marino": 3771.479955,
    "terrestre": 5514.085382
  },
  {
    "a": "2021",
    "marino": 3414.757835,
    "terrestre": 6566.195491
  },
  {
    "a": "2022",
    "marino": 3667.549405,
    "terrestre": 7113.414124
  }
],
reservasUbicacionDatos2P = [
  {
    "a": "2001",
    "marino": 11333.3423,
    "terrestre": 45358.44743
  },
  {
    "a": "2002",
    "marino": 10808.54175,
    "terrestre": 41997.78577
  },
  {
    "a": "2003",
    "marino": 10957.54418,
    "terrestre": 32739.39564
  },
  {
    "a": "2004",
    "marino": 10379.22353,
    "terrestre": 30834.93732
  },
  {
    "a": "2005",
    "marino": 10447.72114,
    "terrestre": 30688.22029
  },
  {
    "a": "2006",
    "marino": 9757.818652,
    "terrestre": 30285.6167
  },
  {
    "a": "2007",
    "marino": 10121.83481,
    "terrestre": 29317.28913
  },
  {
    "a": "2008",
    "marino": 10283.42086,
    "terrestre": 28355.42146
  },
  {
    "a": "2009",
    "marino": 10811.67592,
    "terrestre": 26948.27537
  },
  {
    "a": "2010",
    "marino": 10759.08925,
    "terrestre": 26749.7621
  },
  {
    "a": "2011",
    "marino": 11852.06641,
    "terrestre": 26369.59365
  },
  {
    "a": "2012",
    "marino": 12035.1697,
    "terrestre": 22801.67554
  },
  {
    "a": "2013",
    "marino": 12531.12256,
    "terrestre": 22371.13901
  },
  {
    "a": "2014",
    "marino": 12024.86426,
    "terrestre": 21239.1878
  },
  {
    "a": "2015",
    "marino": 10982.1718,
    "terrestre": 19624.38695
  },
  {
    "a": "2016",
    "marino": 8649.043799,
    "terrestre": 13377.25752
  },
  {
    "a": "2017",
    "marino": 8392.401427,
    "terrestre": 10908.46683
  },
  {
    "a": "2018",
    "marino": 8399.632251,
    "terrestre": 10978.23982
  },
  {
    "a": "2019",
    "marino": 7490.328656,
    "terrestre": 13334.02185
  },
  {
    "a": "2020",
    "marino": 7380.583935,
    "terrestre": 13559.25516
  },
  {
    "a": "2021",
    "marino": 6313.77384,
    "terrestre": 14078.07809
  },
  {
    "a": "2022",
    "marino": 6629.468212,
    "terrestre": 14830.63864
  }
],
reservasUbicacionDatos3P = [
  {
    "a": "2001",
    "marino": 15030.06006,
    "terrestre": 61404.88804
  },
  {
    "a": "2002",
    "marino": 14151.39467,
    "terrestre": 54953.56215
  },
  {
    "a": "2003",
    "marino": 14489.52353,
    "terrestre": 50943.35536
  },
  {
    "a": "2004",
    "marino": 13816.63821,
    "terrestre": 50076.17787
  },
  {
    "a": "2005",
    "marino": 13877.73853,
    "terrestre": 50001.03068
  },
  {
    "a": "2006",
    "marino": 13143.51505,
    "terrestre": 49211.28107
  },
  {
    "a": "2007",
    "marino": 14723.77806,
    "terrestre": 48321.46202
  },
  {
    "a": "2008",
    "marino": 14664.72533,
    "terrestre": 46693.8203
  },
  {
    "a": "2009",
    "marino": 15295.79651,
    "terrestre": 45078.47011
  },
  {
    "a": "2010",
    "marino": 17440.0244,
    "terrestre": 43796.01747
  },
  {
    "a": "2011",
    "marino": 18450.8905,
    "terrestre": 42815.1248
  },
  {
    "a": "2012",
    "marino": 19466.38547,
    "terrestre": 42174.4892
  },
  {
    "a": "2013",
    "marino": 21594.62889,
    "terrestre": 41634.75493
  },
  {
    "a": "2014",
    "marino": 20891.75351,
    "terrestre": 38772.99827
  },
  {
    "a": "2015",
    "marino": 19836.47007,
    "terrestre": 35053.13752
  },
  {
    "a": "2016",
    "marino": 12064.44359,
    "terrestre": 20503.46103
  },
  {
    "a": "2017",
    "marino": 12440.92182,
    "terrestre": 16509.41585
  },
  {
    "a": "2018",
    "marino": 12402.10392,
    "terrestre": 17618.24812
  },
  {
    "a": "2019",
    "marino": 11358.24231,
    "terrestre": 21009.34178
  },
  {
    "a": "2020",
    "marino": 9404.059938,
    "terrestre": 20298.92729
  },
  {
    "a": "2021",
    "marino": 8376.536631,
    "terrestre": 22387.92492
  },
  {
    "a": "2022",
    "marino": 8956.133737,
    "terrestre": 22058.70737
  }
],
reservasUbicacionVariables = [
  {"id":"marino","nombre":"Marino","color":"#0078d7"},
  {"id":"terrestre","nombre":"Terrestre","color":"#ada11d"}
];


</script>
<style scoped lang="scss">
  
  .barrasReservas
  {
    width: 100%;
    height: 500px;
  }

  .barrasReservasUbicacion {
    width: 100%;
    height: 500px;
  }

  .graficaPaises {
    width: 100%;
    height: 600px;
  }


</style>
